import { Component } from "@angular/core";

@Component({
	selector: "app-mech-empty",
	templateUrl: "./mech-empty.component.html",
	styleUrls: ["./mech-empty.component.scss"]
})
export class MechEmptyComponent {

}
